export default __webpack_public_path__ + "static/media/bigcommerce.861c4383.svg";